import { connect } from 'react-redux'
import UnboundContributionsList from './contributions_list'
import {
  pendingContributionsListSelector,
  completedContributionsListSelector,
} from 'redux/selectors/contributions'

export const PendingContributionsList = connect((state, props) => {
  return {
    contributions: pendingContributionsListSelector(state, props),
  }
})(UnboundContributionsList)

export const CompletedActivityList = connect((state, props) => {
  return {
    contributions: completedContributionsListSelector(state, props),
  }
})(UnboundContributionsList)
